/**
 * Purpose: Error class for @ada/copilot-client. Carries a discriminated
 *          `kind` so callers can branch between RPC-domain failures
 *          (server returned a JSON-RPC error envelope) and transport
 *          failures (network, HTTP non-2xx, malformed body).
 *
 * Implementation notes:
 *   - Mirrors the shape of @ada/llm-client's and @ada/credits-client's
 *     error classes for consistency. Each client deliberately ships its
 *     own error type so consumers can write `catch (err) { if (err
 *     instanceof CopilotClientError) ... }` without dragging in the
 *     dispatcher's runtime.
 *
 * Created: 2026-05-08 17:00
 *
 * Changelog:
 *   - 2026-05-08 17:00 — Initial version.
 */
export class CopilotClientError extends Error {
    kind;
    method;
    code;
    httpStatus;
    data;
    cause;
    constructor(message, opts) {
        super(message);
        this.name = 'CopilotClientError';
        this.kind = opts.kind;
        this.method = opts.method;
        if (opts.code !== undefined)
            this.code = opts.code;
        if (opts.httpStatus !== undefined)
            this.httpStatus = opts.httpStatus;
        if (opts.data !== undefined)
            this.data = opts.data;
        if (opts.cause !== undefined)
            this.cause = opts.cause;
    }
}
//# sourceMappingURL=errors.js.map